import {
  PersonalInquiryParams,
  PersonalInquiryResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/personalInquiryQuery/personalInquiry.types.ts';
import axios, { AxiosResponse } from 'axios';

const personalInquiryQueryFunction = ({
  param,
}: PersonalInquiryParams): Promise<AxiosResponse<PersonalInquiryResponse>> => {
  return axios.post(
    'https://develop-inquiry.sanaap.co/inquiry_services/user_info_by_national_codes/2/jibit/identify_by_national_code_inquiry/',
    {
      national_code: param?.national_code,
      birth_date: param?.birth_date,
    },
    {
      headers: {
        Authorization: `jwt ${param?.token}`,
        'Content-Type': 'application/json',
      },
    },
  );
};

export default personalInquiryQueryFunction;
